import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import Popup from '../molecules/Popup';
import { mypage_url } from '../Const';
import { KWANKGM03130A01 } from '../const/api_modules';

interface Props {
  reception_cd: string;
  reception_id: number;
  status_code: number;
  has_debtor?: boolean;
  moveNextStep: (step: number) => void;
  movePrevStep: () => void;
  requestModule: (module_name: string) => Promise<any>;
  handleClickTempSave: () => void; // 一時保存
}

// KWANKGM03130 住宅ローンしっかり審査事前審査申込入力（確認）申込変更 のフッタボタン
const FooterPreExaminationApplicationChangeConfirmationAppHousingLoanFirmly: React.FC<Props> = ({
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
  movePrevStep,
  requestModule,
  handleClickTempSave,
}) => {
  const history = useHistory();
  const [modal_temp_save, setModalTempSave] = useState(false);

  /**
   * ナビゲーションと画面を完了画面に遷移
   */
  const handleClickNext = async () => {
    const result = await requestModule(KWANKGM03130A01);

    // 正常終了か判定
    if (result) {
      // 正常終了なら事前審査受付完了画面に遷移
      moveNextStep(4);
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/finish`);
    }
  };

  /**
   * ナビゲーションを前に遷移
   * 画面をKWANKGM03110_住宅ローンしっかり審査事前審査申込入力詳細 へ遷移
   */
  const handleClickPrev = () => {
    movePrevStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}`);
  };

  /**
   * 『一時保存する』押下
   */
  const handleClickOpenTempSave = () => {
    handleClickTempSave(); // 一時保存のCommonAPIをキックする
    setModalTempSave(true);
  };

  /**
   * 事前審査申込登録前の場合ボタンを表示
   */
  const jsxUsualButton = () => {
    return (
      <>
        <Row className="my-5">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <p>
              連帯債務者等の方(連帯債務・連帯保証で設定している方)にこの借入についてあらかじめ連絡しておいて下さい。
              <br />
              「次へ進む」ボタンを押すと連帯債務者等の方に申込内容確認のためのメールが送信されます。
              <br />
              連帯債務者等がいる場合、連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
              <br />
              連帯債務者等の確認状況はマイページから確認可能です。
            </p>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-no-arrow">
            <div className="text-left sp-button-center">
              <a className="btn btn-xl btn-main-color" onClick={handleClickOpenTempSave}>
                一時保存する
              </a>
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
            <div className="text-right sp-button-center">
              <a
                className="btn btn-xl btn-main-color sp-btn-height ml-auto"
                onClick={handleClickNext}
              >
                次へ進む
              </a>
            </div>
          </Col>
        </Row>

        <Row className="row-left-button">
          <Col className={'text-left p-0'} xl={12} lg={12} md={12} sm={6} xs={6}>
            <div className="text-left sp-button-center">
              <a
                className="btn btn-xl btn-main-color sp-btn-height ml-auto"
                onClick={handleClickPrev}
              >
                戻る
              </a>
            </div>
          </Col>
          <Col xl={6} lg={6} md={6} sm={6} xs={12}></Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {jsxUsualButton()}
      <Popup
        title="一時保存完了"
        text="入力内容を一時保存しました。このまま入力を続けますか？"
        first_button={{
          label: '入力を続ける',
          variant: 'success',
          handleClick: () => setModalTempSave(false),
        }}
        second_button={{
          label: 'マイページへ戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalTempSave(false);
            location.href = mypage_url;
          },
        }}
        toggleClose={() => setModalTempSave(false)}
        toggleShow={modal_temp_save}
      />
    </>
  );
};

export default memo(FooterPreExaminationApplicationChangeConfirmationAppHousingLoanFirmly);
